// extracted by mini-css-extract-plugin
export default {"iframe":"iframe--iq2IR","iframeNoRecaptcha":"iframeNoRecaptcha--SBBWe"};